"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_final_form_1 = require("react-final-form");
var DatePicker_1 = __importDefault(require("shared/components/DateTimePicker/DatePicker"));
var Text_1 = __importDefault(require("shared/components/Text"));
var DateRangeField = function (_a) {
    var name = _a.name, submitting = _a.submitting;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", mb: 2 }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ width: "100%", mr: 2 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { mb: 0.5 } }, { children: "From" })), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: DatePicker_1.default, name: "".concat(name, ".start"), disabled: submitting, label: "Add start date", limitToToday: false, variant: "outlined", InputProps: { size: 'small', color: 'info' } })] })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { mb: 0.5 } }, { children: "To" })), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: DatePicker_1.default, name: "".concat(name, ".end"), disabled: submitting, label: "Add end date", limitToToday: false, variant: "outlined", InputProps: { size: 'small', color: 'info' } })] }))] })));
};
exports.default = DateRangeField;
